import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBanknote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBanknote2"><Path fillRule="evenodd" clipRule="evenodd" d="M1.5 19.5V4.5H22.5V19.5H1.5ZM3 18H5.5C5.5 16.6193 4.38071 15.5 3 15.5V18ZM21 18V15.5C19.6193 15.5 18.5 16.6193 18.5 18H21ZM21 8.5C19.6193 8.5 18.5 7.38071 18.5 6H21V8.5ZM3 6H5.5C5.5 7.38071 4.38071 8.5 3 8.5V6ZM12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBanknote2;
